import alpha from "color-alpha";
import { typography } from "../typography/typography.js";
import "../typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../typography/utils/typographyVariants/typographyVariants.js";
const MuiFormLabel = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...typography["Lato Body 1"],
      color: theme.palette.grey[800],
      "&.MuiInputLabel-filled": {
        transform: "translate(16px, 16px) scale(1)",
        "&.MuiInputLabel-shrink": {
          transform: "translate(16px, 7px) scale(0.75)"
        }
      },
      "&.Mui-focused": {
        color: theme.palette.primary[800]
      },
      "&.Mui-error": {
        color: theme.palette.error[800]
      },
      "&.Mui-disabled": {
        color: alpha(theme.palette.grey[800], 0.38)
      },
      "&.Mui-required::before": {
        content: "'*'",
        color: theme.palette.error[800]
      }
    }),
    asterisk: {
      display: "none"
    }
  }
};
export {
  MuiFormLabel
};
